/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { salesRepStyles } from "@eisinc/App/Components/SalesRep/SalesRep.style";
import { InfoDisplayStyles, infoDisplayStylesTwo } from "@eisinc/App/SharedStyles/InfoDisplayStyles";
import Chat from "@eisinc/XDL/Icons/Chat";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import Clickable from "@insite/mobius/Clickable/Clickable";
import Icon from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import React from "react";
import { connect } from "react-redux";

export interface RepInfoProps {
    salesPersonData: string;
    clickable?: boolean;
    chat?: boolean;
    title?: string;
    billTo?: any;
    extendedStyles?: any;
}

const mapStateToProps = (state: ApplicationState) => ({
    session: getSession(state),
});

type Props = RepInfoProps & ReturnType<typeof mapStateToProps>;

const infoDisplayStyles: InfoDisplayStyles = infoDisplayStylesTwo;

const RepInfo: React.FC<Props> = ({ salesPersonData, clickable, chat, title, billTo, extendedStyles, session }) => {
    const [styles] = React.useState(() => mergeToNew(infoDisplayStyles, extendedStyles));

    if (!salesPersonData) {
        return null;
    }

    const salesPerson = JSON.parse(salesPersonData);

    const handleChatLinkClick = () => {
        const button = document.querySelector('[class^="acOpenButton"]') as HTMLButtonElement | null;

        if (button) {
            button.click();
        } 
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsRepInfo">
                {title || translate("Rep Info")}
            </Typography>
            {salesPerson.Name && (
                <Typography {...styles.contentText} ellipsis={true} as="p">
                    {salesPerson.Name}
                </Typography>
            )}
            {salesPerson.Email && (
                <Typography {...styles.contentText} as="p">
                    {clickable && (
                        <Link href={`mailto:${salesPerson.Email}`} target="_blank">
                            {salesPerson.Email}
                        </Link>
                    )}
                    {!clickable && salesPerson.Email}
                </Typography>
            )}
            {salesPerson.Phone && (
                <Typography {...styles.contentText} as="p">
                    {clickable && (
                        <Link href={`tel:${salesPerson.Phone}`} target="_blank">
                            {salesPerson.Phone}
                        </Link>
                    )}
                    {!clickable && salesPerson.Phone}
                </Typography>
            )}
            {chat && (
                <Clickable {...salesRepStyles.SRChat} onClick={handleChatLinkClick}>
                    {translate("Chat with")} {salesPerson.Name}{" "}
                    <Icon {...salesRepStyles.icon} src={Chat} size={16} color="primary" />
                </Clickable>
            )}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(RepInfo);
